import PdfViewer from "components/PdfViewer/PdfViewer";

const PdfFactor = () => {
    //@ts-ignore
    const filename = JSON.parse(localStorage.getItem("filename"));
    return <>{filename && <PdfViewer pdfURL={filename} />}</>;
};

export default PdfFactor;
